import * as React from 'react';
import {useState} from 'react';
import {FormattedMessage, InjectedIntl, InjectedIntlProps, injectIntl} from 'react-intl';
import * as Yup from "yup";
import {Form, Formik, FormikProps} from "formik";
import {RouteComponentProps, withRouter} from "react-router";
import viaForSchools from "../../assets/viaForSchools.svg";
import {Button} from "@material-ui/core";
import {PageContainer, FormContainer, RowContainer} from '../common/styles';
import * as H from "history";
import {CognitoUser} from "amazon-cognito-identity-js";
import {ToastType} from "../../stores/ui-state.store";
import ToastSnackBar from "../common/toastSnackBar";
import viaLogo from "../../assets/viaLogo.svg";
import {logEvent, MParticleEventName} from "../../utils/m-particle-utils";
import EmailField from "../common/emailField";


enum ForgotPasswordFormFields {
    Email = 'Email',
}

interface OwnProps {
    setUser: (user: CognitoUser | any) => void;
    authClient: any;
    isViaForSchools: boolean;
}

interface FormValues {
    [ForgotPasswordFormFields.Email]: string;
}

const getValidationSchema = (intl: InjectedIntl) => Yup.object().shape({
    [ForgotPasswordFormFields.Email]: Yup.string().email(intl.messages['login.login.email-field-invalid'])
        .required(intl.messages['login.change-password.required']),
});

const initialValues: FormValues = {
    [ForgotPasswordFormFields.Email]: '',
};

const forgotPassword = async (email: string, history: H.History,
                              setUser: (user: CognitoUser | any) => void,
                              setSubmitting: (isSubmitting: boolean) => void,
                              setShowToast: (isSubmitting: boolean) => void,
                              setMessage: (isSubmitting: string) => void,
                              intl: any, authClient: any) => {
    let eventName, params;
    try{
        const cognitoResponse = await authClient.forgotPassword(email);
        setUser({email: email});
        eventName = MParticleEventName.FORGOT_PASSWORD_SEND_EMAIL_SUCCESS;
        params = {username: email};
        if (cognitoResponse.CodeDeliveryDetails && cognitoResponse.CodeDeliveryDetails['Destination']) {
            const destination = cognitoResponse.CodeDeliveryDetails['Destination'];
            history.push({pathname: '/forgotPasswordConfirmation', state: {destination: destination}});
        }
        else{
            history.push('/forgotPasswordConfirmation');
        }
    }
    catch (error) {
        eventName = MParticleEventName.FORGOT_PASSWORD_SEND_EMAIL_FAILURE;
        params = {username: email, errorCode: error.code, errorMessage: error.message};
        if (error.code === "LimitExceededException") {
            setMessage(intl.messages['login.password-confirmation.attempts-exceeded']);
            setShowToast(true);
        }
    }
    finally {
        logEvent(eventName, ForgotPassword.displayName, params);
    }
};

type Props = InjectedIntlProps & FormikProps<FormValues> & RouteComponentProps & OwnProps;

const ForgotPassword = (props: Props) => {
    const { history, intl, setUser, authClient, isViaForSchools } = props;
    const [showToast, setShowToast] = useState(false);
    const [message, setMessage] = useState(intl.messages['login.password-confirmation.attempts-exceeded']);
    const validationSchema = getValidationSchema(intl);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={ async (fields, {setSubmitting}) => {
                await forgotPassword(fields[ForgotPasswordFormFields.Email], history, setUser,
                    setSubmitting, setShowToast, setMessage, intl, authClient);
                setSubmitting(false);
            }}
            render={() => (
                <PageContainer>
                    <FormContainer>
                        <RowContainer style={{backgroundColor: "#F3F5F8", margin: 0}}>
                            <div style={{padding: "20px", margin: "auto"}}>
                                { isViaForSchools ? <img alt="" src={viaForSchools}/> : <img alt="" src={viaLogo}/>}
                            </div>
                        </RowContainer>
                        <Form style={{ display: 'flex', flexDirection: 'column' }}>
                            <RowContainer style={{padding: "15px 60px 0px", flexDirection: "column"}}>
                                <span style={{margin: "auto", padding: "5px", color: "#555555", textAlign: "center"}}>
                                    <FormattedMessage id='login.forgot-password.enter-message'/>
                                </span>
                                <EmailField name={ForgotPasswordFormFields.Email}
                                            label={intl.messages['login.login.email-field']}
                                            id={'forgot-password.email-field'}/>
                                <Button type="submit"
                                        style={{width: "100%", marginTop: "10px", marginBottom: "60px", height: "40px",
                                            backgroundColor: "#20B7E9", color: "white"}}>
                                    <FormattedMessage id='login.forgot-password.send-code-button' />
                                </Button>
                            </RowContainer>
                        </Form>
                    </FormContainer>
                    <ToastSnackBar show={showToast}
                                   message={message}
                                   toastType={ToastType.ERROR}
                                   onClose={() => {setShowToast(false); }}/>
                </PageContainer>
            )} />
    );
};

ForgotPassword.displayName = 'ForgotPassword';
export default withRouter(injectIntl(ForgotPassword));
